import { kmsClient } from '../../apollo';
import { CREATE_FACEBOOK_ADS_MUTATION } from './createFacebookAds.mutation';
import { useMutation } from '@apollo/react-hooks';
import {
  CreateFacebookAdsMutation,
  CreateFacebookAdsMutationVariables
} from './__generated__/CreateFacebookAdsMutation';

export const useCreateFacebookAdsMutation = () => {
  return useMutation<CreateFacebookAdsMutation, CreateFacebookAdsMutationVariables>(CREATE_FACEBOOK_ADS_MUTATION, {
    client: kmsClient
  });
};
